import React from 'react';
import BaseQuestion from './BaseQuestion';
import { QUESTION_TYPES } from '../../constants/question-types';

/**
 * Question component for Date Picker configuration
 */
const DatePickerQuestion = ({
    question,
    questionIndex,
    onUpdate,
    onRemove,
    onMoveUp,
    onMoveDown,
    isFirst,
    isLast,
}) => {
    const config = question.config || {};

    const handleConfigChange = (key, value) => {
        onUpdate(questionIndex, {
            config: {
                ...config,
                [key]: value || null,
            },
        });
    };

    return (
        <BaseQuestion
            question={question}
            questionIndex={questionIndex}
            onUpdate={onUpdate}
            onRemove={onRemove}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            isFirst={isFirst}
            isLast={isLast}
            questionType={QUESTION_TYPES.DATE_PICKER}
            questionTypeLabel="Date"
            questionTypeIcon="📅"
        >
            <div className="mt-3 p-3 bg-light rounded border">
                <h6 className="mb-3 text-secondary">Date Settings</h6>
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label small fw-bold text-secondary">
                            Earliest Date (Optional)
                        </label>
                        <input
                            type="date"
                            className="form-control"
                            value={config.minDate || ''}
                            onChange={(e) => handleConfigChange('minDate', e.target.value)}
                            max={config.maxDate || undefined}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label small fw-bold text-secondary">
                            Latest Date (Optional)
                        </label>
                        <input
                            type="date"
                            className="form-control"
                            value={config.maxDate || ''}
                            onChange={(e) => handleConfigChange('maxDate', e.target.value)}
                            min={config.minDate || undefined}
                        />
                    </div>
                </div>
                <div className="form-text mt-2">
                    Respondents will only be able to select dates between these ranges. Leave empty for no restriction.
                </div>
            </div>
        </BaseQuestion>
    );
};

export default DatePickerQuestion;
